(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multicolumn"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', () => {
    if (document.querySelector('.multicolumn--technology') && document.fonts) {
      document.fonts.ready.then(() => window.findTallestHeight?.());
    }
  });
  } catch(e) { console.error(e); }
})();

})();
